import type { IntlShape } from 'react-intl';
import { generatePath } from 'react-router-dom';

import { RoutePathType } from './enums';

export const getNavActions = (intl: IntlShape) => ({
  [RoutePathType.AdminConsoleClient]: [
    {
      text: intl.formatMessage({
        id: 'Nav.adminConsole',
        defaultMessage: 'Admin Console',
        description: 'Navigation text for Admin Console',
      }),
      pathname: RoutePathType.AdminConsoleClient,
    },
  ],
  [RoutePathType.Admin]: [
    {
      text: intl.formatMessage({
        id: 'Nav.admin',
        defaultMessage: 'Admin',
        description: 'Navigation text for Admin section',
      }),
      pathname: RoutePathType.Admin,
    },
  ],
});

interface NavAction {
  text: string;
  pathname: RoutePathType;
}

export const generateNav = ({
  current,
  from,
  params,
  intl,
}: {
  current: NavAction;
  from: RoutePathType.AdminConsoleClient | RoutePathType.Admin;
  params: object;
  intl: IntlShape;
}) => {
  const navActions = getNavActions(intl);
  const actions = [...navActions[from], current].map((action) => ({
    ...action,
    pathname: generatePath(action.pathname, params),
  }));

  return { actions };
};
